import script from "./LicenseWindowDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseWindowDialog.vue?vue&type=script&setup=true&lang=js"

import "./LicenseWindowDialog.vue?vue&type=style&index=0&id=3c1f2761&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1f2761"]])

export default __exports__